import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Header, Footer } from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import AboutJasonPage from "@/pages/AboutJasonPage";
import MotivationalSpeakingPage from "@/pages/MotivationalSpeakingPage";
import VRCampusPage from "@/pages/VRCampusPage";
import VRDemoVideosPage from "@/pages/VRDemoVideosPage";
import OtherProgramsPage from "@/pages/OtherProgramsPage";
import VRChatMetaQuestPage from "@/pages/VRChatMetaQuestPage";
import BooksPage from "@/pages/BooksPage";
import MediaPage from "@/pages/MediaPage";
import ContactPage from "@/pages/ContactPage";
import DonatePage from "@/pages/DonatePage";
import AdminPage from "@/pages/AdminPage";
import ServicesPage from "@/pages/ServicesPage";
import CoursesPage from "@/pages/CoursesPage";
import EventsPage from "@/pages/EventsPage";
import EbooksPage from "@/pages/EbooksPage";
import ComingSoonPage from "@/pages/ComingSoonPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import SponsorshipPage from "@/pages/SponsorshipPage";
import MerchandisePage from "@/pages/MerchandisePage";
import InternationalResellerPage from "@/pages/InternationalResellerPage";

// Coming Soon Mode - Set to true to enable, false to disable
const COMING_SOON_MODE = false;
// Secret preview key - add ?preview=matrixvr2026 to URL to bypass coming soon
const PREVIEW_KEY = "matrixvr2026";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Layout wrapper
const Layout = ({ children, showHeaderFooter = true }) => {
  return (
    <>
      {showHeaderFooter && <Header />}
      <main className="min-h-screen">
        {children}
      </main>
      {showHeaderFooter && <Footer />}
    </>
  );
};

// Protected Route - redirects to coming soon if in coming soon mode
const ProtectedRoute = ({ children, isPreviewMode }) => {
  if (COMING_SOON_MODE && !isPreviewMode) {
    return <Navigate to="/" replace />;
  }
  return children;
};

function App() {
  const [isPreviewMode, setIsPreviewMode] = useState(false);

  useEffect(() => {
    // Check for preview key in URL or localStorage
    const urlParams = new URLSearchParams(window.location.search);
    const previewParam = urlParams.get('preview');
    const storedPreview = localStorage.getItem('matrixPreviewMode');
    
    if (previewParam === PREVIEW_KEY) {
      localStorage.setItem('matrixPreviewMode', 'true');
      setIsPreviewMode(true);
    } else if (storedPreview === 'true') {
      setIsPreviewMode(true);
    }
  }, []);

  // If coming soon mode is enabled and not in preview mode, show only coming soon page
  if (COMING_SOON_MODE && !isPreviewMode) {
    return (
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<Layout showHeaderFooter={false}><AdminPage /></Layout>} />
            <Route path="*" element={<ComingSoonPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="scan-line" />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Routes with Header/Footer */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
          <Route path="/about-jason" element={<Layout><AboutJasonPage /></Layout>} />
          <Route path="/motivational-speaking" element={<Layout><MotivationalSpeakingPage /></Layout>} />
          <Route path="/courses" element={<Layout><CoursesPage /></Layout>} />
          <Route path="/vr-campus" element={<Layout><VRCampusPage /></Layout>} />
          <Route path="/vr-demo-videos" element={<Layout><VRDemoVideosPage /></Layout>} />
          <Route path="/other-programs" element={<Layout><OtherProgramsPage /></Layout>} />
          <Route path="/vr-chat-meta-quest" element={<Layout><VRChatMetaQuestPage /></Layout>} />
          <Route path="/ebooks" element={<Layout><EbooksPage /></Layout>} />
          <Route path="/books" element={<Layout><BooksPage /></Layout>} />
          <Route path="/events" element={<Layout><EventsPage /></Layout>} />
          <Route path="/media" element={<Layout><MediaPage /></Layout>} />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
          <Route path="/donate" element={<Layout><DonatePage /></Layout>} />
          <Route path="/donate/success" element={<Layout><DonatePage /></Layout>} />
          <Route path="/sponsorship" element={<Layout><SponsorshipPage /></Layout>} />
          <Route path="/merchandise" element={<Layout><MerchandisePage /></Layout>} />
          <Route path="/international-reseller" element={<Layout><InternationalResellerPage /></Layout>} />
          <Route path="/checkout/success" element={<Layout><CheckoutSuccessPage /></Layout>} />
          
          {/* Admin Route without Header/Footer */}
          <Route path="/admin" element={<Layout showHeaderFooter={false}><AdminPage /></Layout>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
